import { render, staticRenderFns } from "./Index-template.vue?vue&type=template&id=01bfba66&"
import script from "./Index-template.vue?vue&type=script&lang=ts&"
export * from "./Index-template.vue?vue&type=script&lang=ts&"
import style0 from "./Index-template.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports